import { Column, Columns } from 'braid-design-system';

import GenericAsiaBannerSection from './GenericAsiaBannerSection';
import useGenericAsiaMarketingContent from './useGenericAsiaMarketingContent';

const GenericAsiaBanner = () => {
  const [candidateBannerProps, hirerBannerProps] =
    useGenericAsiaMarketingContent();

  return (
    <Columns
      collapseBelow="tablet"
      space={{
        mobile: 'small',
        tablet: 'small',
        desktop: 'medium',
        wide: 'medium',
      }}
    >
      <Column>
        <GenericAsiaBannerSection {...candidateBannerProps} />
      </Column>
      <Column>
        <GenericAsiaBannerSection {...hirerBannerProps} />
      </Column>
    </Columns>
  );
};

export default GenericAsiaBanner;
